export function withListedBalance(account: any) {
  if (account == null) return account
  if (account.balance != null && Number.isFinite(Number(account.balance))) {
    return {...account, balance: Number(account.balance)}
  }
  if (account.storedBalance == null) return account
  return {...account, balance: Number(account.storedBalance)}
}
